import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Table, Button, OverlayTrigger, Tooltip, Badge, Spinner } from 'react-bootstrap';
import { FaSearch, FaEye } from "react-icons/fa";
import APIServicenew from "../../utils/APIGeneralService";
import { UserContext } from "../../context/UserContextProvider";
import { ToastContainer, toast } from "react-toastify";
import Paginator from "../../components/common/Pagination";
import { formateDatemdy } from "../../utils/Helper";

const ActionLogs = () => {
  const navigate = useNavigate();
  const limit = 10;

  const [logs, setLogs] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [searchQuery, setSearchQuery] = useState("");

  const APIServices = new APIServicenew(process.env.REACT_APP_OTHER_API_URL);
  const authToken = process.env.REACT_APP_authToken;
  const { accessToken, logout } = useContext(UserContext);

  const headers = {
    "Content-Type": "application/json",
    "auth-token": authToken,
    "authorization": accessToken
  };

  useEffect(() => {
    fetchLogs();
  }, [currentPage, searchQuery]);

  const fetchLogs = async () => {
    setLoading(true);
    try {
      const params = {
        skip: (currentPage - 1) * limit,
        limit: limit,
      };

      if (searchQuery && searchQuery.trim() !== "") {
        params.search = searchQuery.trim();
      }

      const queryString = new URLSearchParams(params).toString();

      const response = await APIServices.get(
        `/admin/cms/action_logs?${queryString}`,
        headers
      );

      if (response?.data?.status === true) {
        setLogs(response?.data?.data?.logs || []);
        setTotalCount(response?.data?.data?.total || 0);
      } else if (response?.status === 401) {
        logout();
        navigate("/");
      } else {
        setLogs([]);
        setTotalCount(0);
      }
    } catch (error) {
      console.error("Error fetching action logs:", error);
      showToast("Error fetching action logs", "error");
      setLogs([]);
      setTotalCount(0);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (e) => {
    e.preventDefault();
    setSearchQuery(search);
    setCurrentPage(1);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const getActionBadge = (action) => {
    switch (action) {
      case 'CREATE':
        return <Badge bg="success">{action}</Badge>;
      case 'UPDATE':
        return <Badge bg="warning" className="text-dark">{action}</Badge>;
      case 'DELETE':
        return <Badge bg="danger">{action}</Badge>;
      case 'DUPLICATE':
        return <Badge bg="info">{action}</Badge>;
      default:
        return <Badge bg="secondary">{action}</Badge>;
    }
  };

  const showToast = (message, type) => {
    toast(message, {
      position: "top-right",
      autoClose: 2000,
      type,
      hideProgressBar: false,
      closeOnClick: true,
    });
  };

  const totalPages = Math.ceil(totalCount / limit) || 0;

  return (
    <>
      <div className="action_logs_page">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h1 className="font_blue_18 font-600">
            Action Logs ({totalCount})
          </h1>
        </div>

        <div className=" mb-4">
          <div className="">
            <form onSubmit={handleSearch} className="d-flex gap-2">
              <div className="input-group" style={{ maxWidth: "600px" }}>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search (CREATE, DELETE, student...)"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
                <Button variant="primary" type="submit">
                  <FaSearch />
                </Button>
              </div>
              {searchQuery && (
                <Button
                  variant="outline-secondary"
                  onClick={() => {
                    setSearch("");
                    setSearchQuery("");
                    setCurrentPage(1);
                  }}
                >
                  Clear
                </Button>
              )}
            </form>
          </div>
        </div>

        <div className="todoList_table">
          <div className="table-responsive">
            <Table className="table">
              <thead className="table-dark">
                <tr>
                  <th style={{ width: '5%' }}>#</th>
                  <th style={{ width: '10%' }}>Table</th>
                  <th style={{ width: '8%' }}>Action</th>
                  <th style={{ width: '20%' }}>Description</th>
                  <th style={{ width: '12%' }}>Performed By</th>
                  <th style={{ width: '10%' }}>IP Address</th>
                  <th style={{ width: '12%' }}>Date</th>
                  <th style={{ width: '15%' }}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="9" className="text-center py-4">
                      <Spinner animation="border" variant="primary" />
                    </td>
                  </tr>
                ) : logs.length > 0 ? (
                  logs.map((log, index) => (
                    <tr key={log.id}>
                      <td>{(currentPage - 1) * limit + index + 1}</td>
                      <td>
                        <strong>{log.table_name}</strong>
                      </td>
                      
                      <td>{getActionBadge(log.action)}</td>
                      <td>
                        <small>{log.description}</small>
                      </td>
                      <td>
                        <div>
                          <strong>{log.performer_name}</strong>
                          <br />
                          <small className="text-muted">({log.perform_by})</small>
                        </div>
                      </td>
                      <td>
                        <small className="text-muted">{log.ip_address}</small>
                      </td>
                      <td>{formateDatemdy(log.created)}</td>
                      <td>
                        <OverlayTrigger placement="top" overlay={<Tooltip>View Details</Tooltip>}>
                          <Button
                            variant="outline-info"
                            size="sm"
                            onClick={() => {
                              navigate(`/admin/action_log_detail/${log.id}`, {
                                state: { log },
                              });
                            }}
                          >
                            <FaEye />
                          </Button>
                        </OverlayTrigger>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="9" className="text-center py-4">
                      <div className="text-muted">
                        <h5>No Action Logs found</h5>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        </div>

        <div className="pagination_box mt-4">
          {totalCount > limit && (
            <Paginator
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
            />
          )}
        </div>
      </div>

      <ToastContainer />
    </>
  );
};

export default ActionLogs;